// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AccountDisabledRouteImport } from './routes/account-disabled'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppAdminRouteImport } from './routes/_app/_admin'
import { Route as AppHrRouteImport } from './routes/_app/_hr'
import { Route as AppTeamRouteImport } from './routes/_app/_team'
import { Route as AppAdsPerformanceRouteImport } from './routes/_app/ads-performance'
import { Route as AppBoardsRouteImport } from './routes/_app/boards'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppChatRouteImport } from './routes/_app/chat'
import { Route as AppCorrectionsRouteImport } from './routes/_app/corrections'
import { Route as AppCreativeLibraryRouteImport } from './routes/_app/creative-library'
import { Route as AppCreativeProductionRouteImport } from './routes/_app/creative-production'
import { Route as AppCreativesRouteImport } from './routes/_app/creatives'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppMetaIdsRouteImport } from './routes/_app/meta-ids'
import { Route as AppMfaChallengeRouteImport } from './routes/_app/mfa-challenge'
import { Route as AppMySubmissionsRouteImport } from './routes/_app/my-submissions'
import { Route as AppPerformanceRouteImport } from './routes/_app/performance'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSopsRouteImport } from './routes/_app/sops'
import { Route as AppTodayTasksRouteImport } from './routes/_app/today-tasks'
import { Route as AppUpdateTaskRouteImport } from './routes/_app/update-task'
import { Route as AppVaultRouteImport } from './routes/_app/vault'
import { Route as AppWinnersRouteImport } from './routes/_app/winners'
import { Route as AppBoardsIndexRouteImport } from './routes/_app/boards.index'
import { Route as AppBoardsIdRouteImport } from './routes/_app/boards.$id'
import { Route as AppBoardsNewRouteImport } from './routes/_app/boards.new'
import { Route as AppCalendarIntelligenceRouteImport } from './routes/_app/calendar_.intelligence'
import { Route as AppLeaveApplyRouteImport } from './routes/_app/leave.apply'
import { Route as AppLeaveMyLeavesRouteImport } from './routes/_app/leave.my-leaves'
import { Route as AppNotificationsHistoryRouteImport } from './routes/_app/notifications.history'
import { Route as AppNotificationsSendRouteImport } from './routes/_app/notifications.send'
import { Route as AppSettingsColorThemeRouteImport } from './routes/_app/settings_.color-theme'
import { Route as AppTodayTasksIdRouteImport } from './routes/_app/today-tasks_.$id'
import { Route as AppVaultEntriesRouteImport } from './routes/_app/vault_.entries'
import { Route as AppAdminAdminAssignTaskRouteImport } from './routes/_app/_admin/admin.assign-task'
import { Route as AppAdminAdminAuditLogRouteImport } from './routes/_app/_admin/admin.audit-log'
import { Route as AppAdminAdminDepartmentsRouteImport } from './routes/_app/_admin/admin.departments'
import { Route as AppAdminAdminModeratorAuditRouteImport } from './routes/_app/_admin/admin.moderator-audit'
import { Route as AppAdminAdminModeratorsRouteImport } from './routes/_app/_admin/admin.moderators'
import { Route as AppAdminAdminOverviewRouteImport } from './routes/_app/_admin/admin.overview'
import { Route as AppAdminAdminSettingsRouteImport } from './routes/_app/_admin/admin.settings'
import { Route as AppAdminAdminUsersRouteImport } from './routes/_app/_admin/admin.users'
import { Route as AppHrHrAssetsRouteImport } from './routes/_app/_hr/hr.assets'
import { Route as AppHrHrDirectoryRouteImport } from './routes/_app/_hr/hr.directory'
import { Route as AppHrHrDocumentsRouteImport } from './routes/_app/_hr/hr.documents'
import { Route as AppHrHrExitReviewsRouteImport } from './routes/_app/_hr/hr.exit-reviews'
import { Route as AppHrHrLeaveRouteImport } from './routes/_app/_hr/hr.leave'
import { Route as AppHrHrPayrollRouteImport } from './routes/_app/_hr/hr.payroll'
import { Route as AppHrHrRecruitmentRouteImport } from './routes/_app/_hr/hr.recruitment'
import { Route as AppTeamTeamActivityRouteImport } from './routes/_app/_team/team.activity'
import { Route as AppTeamTeamDepartmentsRouteImport } from './routes/_app/_team/team.departments'
import { Route as AppTeamTeamEmployeesRouteImport } from './routes/_app/_team/team.employees'
import { Route as AppTeamTeamOverviewRouteImport } from './routes/_app/_team/team.overview'
import { Route as AppBoardsIdTimelineRouteImport } from './routes/_app/boards.$id_.timeline'
import { Route as AppAdminAdminSettingsAdsRouteImport } from './routes/_app/_admin/admin.settings.ads'
import { Route as AppAdminAdminSettingsIntegrationsRouteImport } from './routes/_app/_admin/admin.settings.integrations'
import { Route as AppAdminAdminSettingsLookupsRouteImport } from './routes/_app/_admin/admin.settings.lookups'
import { Route as AppHrHrProfileIdRouteImport } from './routes/_app/_hr/hr.profile.$id'
import { Route as AppTeamTeamUsersIdRouteImport } from './routes/_app/_team/team.users.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AccountDisabledRoute = AccountDisabledRouteImport.update({
            id: '/account-disabled',path: '/account-disabled',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const AppAdminRoute = AppAdminRouteImport.update({
            id: '/_admin',getParentRoute: () => AppRoute
          })
const AppHrRoute = AppHrRouteImport.update({
            id: '/_hr',getParentRoute: () => AppRoute
          })
const AppTeamRoute = AppTeamRouteImport.update({
            id: '/_team',getParentRoute: () => AppRoute
          })
const AppAdsPerformanceRoute = AppAdsPerformanceRouteImport.update({
            id: '/ads-performance',path: '/ads-performance',getParentRoute: () => AppRoute
          })
const AppBoardsRoute = AppBoardsRouteImport.update({
            id: '/boards',path: '/boards',getParentRoute: () => AppRoute
          })
const AppCalendarRoute = AppCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AppRoute
          })
const AppChatRoute = AppChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AppRoute
          })
const AppCorrectionsRoute = AppCorrectionsRouteImport.update({
            id: '/corrections',path: '/corrections',getParentRoute: () => AppRoute
          })
const AppCreativeLibraryRoute = AppCreativeLibraryRouteImport.update({
            id: '/creative-library',path: '/creative-library',getParentRoute: () => AppRoute
          })
const AppCreativeProductionRoute = AppCreativeProductionRouteImport.update({
            id: '/creative-production',path: '/creative-production',getParentRoute: () => AppRoute
          })
const AppCreativesRoute = AppCreativesRouteImport.update({
            id: '/creatives',path: '/creatives',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppMetaIdsRoute = AppMetaIdsRouteImport.update({
            id: '/meta-ids',path: '/meta-ids',getParentRoute: () => AppRoute
          })
const AppMfaChallengeRoute = AppMfaChallengeRouteImport.update({
            id: '/mfa-challenge',path: '/mfa-challenge',getParentRoute: () => AppRoute
          })
const AppMySubmissionsRoute = AppMySubmissionsRouteImport.update({
            id: '/my-submissions',path: '/my-submissions',getParentRoute: () => AppRoute
          })
const AppPerformanceRoute = AppPerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => AppRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppSopsRoute = AppSopsRouteImport.update({
            id: '/sops',path: '/sops',getParentRoute: () => AppRoute
          })
const AppTodayTasksRoute = AppTodayTasksRouteImport.update({
            id: '/today-tasks',path: '/today-tasks',getParentRoute: () => AppRoute
          })
const AppUpdateTaskRoute = AppUpdateTaskRouteImport.update({
            id: '/update-task',path: '/update-task',getParentRoute: () => AppRoute
          })
const AppVaultRoute = AppVaultRouteImport.update({
            id: '/vault',path: '/vault',getParentRoute: () => AppRoute
          })
const AppWinnersRoute = AppWinnersRouteImport.update({
            id: '/winners',path: '/winners',getParentRoute: () => AppRoute
          })
const AppBoardsIndexRoute = AppBoardsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBoardsRoute
          })
const AppBoardsIdRoute = AppBoardsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AppBoardsRoute
          })
const AppBoardsNewRoute = AppBoardsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AppBoardsRoute
          })
const AppCalendarIntelligenceRoute = AppCalendarIntelligenceRouteImport.update({
            id: '/calendar_/intelligence',path: '/calendar/intelligence',getParentRoute: () => AppRoute
          })
const AppLeaveApplyRoute = AppLeaveApplyRouteImport.update({
            id: '/leave/apply',path: '/leave/apply',getParentRoute: () => AppRoute
          })
const AppLeaveMyLeavesRoute = AppLeaveMyLeavesRouteImport.update({
            id: '/leave/my-leaves',path: '/leave/my-leaves',getParentRoute: () => AppRoute
          })
const AppNotificationsHistoryRoute = AppNotificationsHistoryRouteImport.update({
            id: '/notifications/history',path: '/notifications/history',getParentRoute: () => AppRoute
          })
const AppNotificationsSendRoute = AppNotificationsSendRouteImport.update({
            id: '/notifications/send',path: '/notifications/send',getParentRoute: () => AppRoute
          })
const AppSettingsColorThemeRoute = AppSettingsColorThemeRouteImport.update({
            id: '/settings_/color-theme',path: '/settings/color-theme',getParentRoute: () => AppRoute
          })
const AppTodayTasksIdRoute = AppTodayTasksIdRouteImport.update({
            id: '/today-tasks_/$id',path: '/today-tasks/$id',getParentRoute: () => AppRoute
          })
const AppVaultEntriesRoute = AppVaultEntriesRouteImport.update({
            id: '/vault_/entries',path: '/vault/entries',getParentRoute: () => AppRoute
          })
const AppAdminAdminAssignTaskRoute = AppAdminAdminAssignTaskRouteImport.update({
            id: '/admin/assign-task',path: '/admin/assign-task',getParentRoute: () => AppAdminRoute
          })
const AppAdminAdminAuditLogRoute = AppAdminAdminAuditLogRouteImport.update({
            id: '/admin/audit-log',path: '/admin/audit-log',getParentRoute: () => AppAdminRoute
          })
const AppAdminAdminDepartmentsRoute = AppAdminAdminDepartmentsRouteImport.update({
            id: '/admin/departments',path: '/admin/departments',getParentRoute: () => AppAdminRoute
          })
const AppAdminAdminModeratorAuditRoute = AppAdminAdminModeratorAuditRouteImport.update({
            id: '/admin/moderator-audit',path: '/admin/moderator-audit',getParentRoute: () => AppAdminRoute
          })
const AppAdminAdminModeratorsRoute = AppAdminAdminModeratorsRouteImport.update({
            id: '/admin/moderators',path: '/admin/moderators',getParentRoute: () => AppAdminRoute
          })
const AppAdminAdminOverviewRoute = AppAdminAdminOverviewRouteImport.update({
            id: '/admin/overview',path: '/admin/overview',getParentRoute: () => AppAdminRoute
          })
const AppAdminAdminSettingsRoute = AppAdminAdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => AppAdminRoute
          })
const AppAdminAdminUsersRoute = AppAdminAdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => AppAdminRoute
          })
const AppHrHrAssetsRoute = AppHrHrAssetsRouteImport.update({
            id: '/hr/assets',path: '/hr/assets',getParentRoute: () => AppHrRoute
          })
const AppHrHrDirectoryRoute = AppHrHrDirectoryRouteImport.update({
            id: '/hr/directory',path: '/hr/directory',getParentRoute: () => AppHrRoute
          })
const AppHrHrDocumentsRoute = AppHrHrDocumentsRouteImport.update({
            id: '/hr/documents',path: '/hr/documents',getParentRoute: () => AppHrRoute
          })
const AppHrHrExitReviewsRoute = AppHrHrExitReviewsRouteImport.update({
            id: '/hr/exit-reviews',path: '/hr/exit-reviews',getParentRoute: () => AppHrRoute
          })
const AppHrHrLeaveRoute = AppHrHrLeaveRouteImport.update({
            id: '/hr/leave',path: '/hr/leave',getParentRoute: () => AppHrRoute
          })
const AppHrHrPayrollRoute = AppHrHrPayrollRouteImport.update({
            id: '/hr/payroll',path: '/hr/payroll',getParentRoute: () => AppHrRoute
          })
const AppHrHrRecruitmentRoute = AppHrHrRecruitmentRouteImport.update({
            id: '/hr/recruitment',path: '/hr/recruitment',getParentRoute: () => AppHrRoute
          })
const AppTeamTeamActivityRoute = AppTeamTeamActivityRouteImport.update({
            id: '/team/activity',path: '/team/activity',getParentRoute: () => AppTeamRoute
          })
const AppTeamTeamDepartmentsRoute = AppTeamTeamDepartmentsRouteImport.update({
            id: '/team/departments',path: '/team/departments',getParentRoute: () => AppTeamRoute
          })
const AppTeamTeamEmployeesRoute = AppTeamTeamEmployeesRouteImport.update({
            id: '/team/employees',path: '/team/employees',getParentRoute: () => AppTeamRoute
          })
const AppTeamTeamOverviewRoute = AppTeamTeamOverviewRouteImport.update({
            id: '/team/overview',path: '/team/overview',getParentRoute: () => AppTeamRoute
          })
const AppBoardsIdTimelineRoute = AppBoardsIdTimelineRouteImport.update({
            id: '/$id_/timeline',path: '/$id/timeline',getParentRoute: () => AppBoardsRoute
          })
const AppAdminAdminSettingsAdsRoute = AppAdminAdminSettingsAdsRouteImport.update({
            id: '/ads',path: '/ads',getParentRoute: () => AppAdminAdminSettingsRoute
          })
const AppAdminAdminSettingsIntegrationsRoute = AppAdminAdminSettingsIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AppAdminAdminSettingsRoute
          })
const AppAdminAdminSettingsLookupsRoute = AppAdminAdminSettingsLookupsRouteImport.update({
            id: '/lookups',path: '/lookups',getParentRoute: () => AppAdminAdminSettingsRoute
          })
const AppHrHrProfileIdRoute = AppHrHrProfileIdRouteImport.update({
            id: '/hr/profile/$id',path: '/hr/profile/$id',getParentRoute: () => AppHrRoute
          })
const AppTeamTeamUsersIdRoute = AppTeamTeamUsersIdRouteImport.update({
            id: '/team/users/$id',path: '/team/users/$id',getParentRoute: () => AppTeamRoute
          })





const AppAdminAdminSettingsRouteChildren = {
  AppAdminAdminSettingsAdsRoute: AppAdminAdminSettingsAdsRoute,AppAdminAdminSettingsIntegrationsRoute: AppAdminAdminSettingsIntegrationsRoute,AppAdminAdminSettingsLookupsRoute: AppAdminAdminSettingsLookupsRoute
}

const AppAdminAdminSettingsRouteWithChildren = AppAdminAdminSettingsRoute._addFileChildren(AppAdminAdminSettingsRouteChildren)



const AppAdminRouteChildren = {
  AppAdminAdminAssignTaskRoute: AppAdminAdminAssignTaskRoute,AppAdminAdminAuditLogRoute: AppAdminAdminAuditLogRoute,AppAdminAdminDepartmentsRoute: AppAdminAdminDepartmentsRoute,AppAdminAdminModeratorAuditRoute: AppAdminAdminModeratorAuditRoute,AppAdminAdminModeratorsRoute: AppAdminAdminModeratorsRoute,AppAdminAdminOverviewRoute: AppAdminAdminOverviewRoute,AppAdminAdminSettingsRoute: AppAdminAdminSettingsRouteWithChildren,AppAdminAdminUsersRoute: AppAdminAdminUsersRoute
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(AppAdminRouteChildren)




const AppHrRouteChildren = {
  AppHrHrAssetsRoute: AppHrHrAssetsRoute,AppHrHrDirectoryRoute: AppHrHrDirectoryRoute,AppHrHrDocumentsRoute: AppHrHrDocumentsRoute,AppHrHrExitReviewsRoute: AppHrHrExitReviewsRoute,AppHrHrLeaveRoute: AppHrHrLeaveRoute,AppHrHrPayrollRoute: AppHrHrPayrollRoute,AppHrHrRecruitmentRoute: AppHrHrRecruitmentRoute,AppHrHrProfileIdRoute: AppHrHrProfileIdRoute
}

const AppHrRouteWithChildren = AppHrRoute._addFileChildren(AppHrRouteChildren)




const AppTeamRouteChildren = {
  AppTeamTeamActivityRoute: AppTeamTeamActivityRoute,AppTeamTeamDepartmentsRoute: AppTeamTeamDepartmentsRoute,AppTeamTeamEmployeesRoute: AppTeamTeamEmployeesRoute,AppTeamTeamOverviewRoute: AppTeamTeamOverviewRoute,AppTeamTeamUsersIdRoute: AppTeamTeamUsersIdRoute
}

const AppTeamRouteWithChildren = AppTeamRoute._addFileChildren(AppTeamRouteChildren)




const AppBoardsRouteChildren = {
  AppBoardsIdRoute: AppBoardsIdRoute,AppBoardsNewRoute: AppBoardsNewRoute,AppBoardsIndexRoute: AppBoardsIndexRoute,AppBoardsIdTimelineRoute: AppBoardsIdTimelineRoute
}

const AppBoardsRouteWithChildren = AppBoardsRoute._addFileChildren(AppBoardsRouteChildren)



const AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,AppHrRoute: AppHrRouteWithChildren,AppTeamRoute: AppTeamRouteWithChildren,AppAdsPerformanceRoute: AppAdsPerformanceRoute,AppBoardsRoute: AppBoardsRouteWithChildren,AppCalendarRoute: AppCalendarRoute,AppChatRoute: AppChatRoute,AppCorrectionsRoute: AppCorrectionsRoute,AppCreativeLibraryRoute: AppCreativeLibraryRoute,AppCreativeProductionRoute: AppCreativeProductionRoute,AppCreativesRoute: AppCreativesRoute,AppDashboardRoute: AppDashboardRoute,AppMetaIdsRoute: AppMetaIdsRoute,AppMfaChallengeRoute: AppMfaChallengeRoute,AppMySubmissionsRoute: AppMySubmissionsRoute,AppPerformanceRoute: AppPerformanceRoute,AppSettingsRoute: AppSettingsRoute,AppSopsRoute: AppSopsRoute,AppTodayTasksRoute: AppTodayTasksRoute,AppUpdateTaskRoute: AppUpdateTaskRoute,AppVaultRoute: AppVaultRoute,AppWinnersRoute: AppWinnersRoute,AppCalendarIntelligenceRoute: AppCalendarIntelligenceRoute,AppLeaveApplyRoute: AppLeaveApplyRoute,AppLeaveMyLeavesRoute: AppLeaveMyLeavesRoute,AppNotificationsHistoryRoute: AppNotificationsHistoryRoute,AppNotificationsSendRoute: AppNotificationsSendRoute,AppSettingsColorThemeRoute: AppSettingsColorThemeRoute,AppTodayTasksIdRoute: AppTodayTasksIdRoute,AppVaultEntriesRoute: AppVaultEntriesRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AccountDisabledRoute: AccountDisabledRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,ResetPasswordRoute: ResetPasswordRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)